import React from "react";
import { Box, Typography, Container, Paper, Stack } from "@mui/material";
import { RocketLaunch } from "@mui/icons-material";
import { useAppContext } from "../../../context";

/**
 * UserDashboard - React MUI component replacing web/app_home.html
 *
 * This component provides the main user dashboard (home page) with:
 * - Welcome message matching Django template design
 * - Team information display
 * - Clean, friendly design with rocket illustration concept
 * - Instructions for extending the page
 */

const UserDashboard: React.FC = () => {
  const { team } = useAppContext();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 4 } }}>
      {/* Main Welcome Section */}
      <Paper elevation={1} sx={{ p: { xs: 2, sm: 4 }, mb: 3, minWidth: 0 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          alignItems="center"
        >
          {/* Content */}
          <Box sx={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>
            <Stack spacing={2}>
              <Typography variant="h3" component="h1" fontWeight="bold">
                You're Signed In!
              </Typography>
              <Typography variant="h5" component="h2" color="text.secondary">
                This is your application's logged in home page.
              </Typography>
              {team && (
                <Typography variant="body1">
                  You're logged into the "{team.name}" Team.
                </Typography>
              )}
            </Stack>
          </Box>

          {/* Rocket Illustration */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 200,
              flexShrink: 0,
            }}
          >
            {/* Using Material-UI icon as fallback for the rocket illustration */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: { xs: 144, sm: 200 },
                maxWidth: '100%',
                aspectRatio: '1',
                borderRadius: "50%",
                background: "linear-gradient(135deg, #3D438F 0%, #5A327A 100%)",
                color: "white",
              }}
            >
              <RocketLaunch sx={{ fontSize: 80 }} />
            </Box>
          </Box>
        </Stack>
      </Paper>
    </Container>
  );
};

export default UserDashboard;
